import { getDocs } from 'firebase/firestore/lite'
import refs from '../refsLite'
import { ExtensionInstallation } from '@learnics/models/src/ExtensionInstallation/ExtensionInstallation.mjs'

export async function getInstallationsIndex() {
  console.log('Getting installations index...')
  const userIndexChunks = await getDocs(refs.installationsIndexChunks())
  const installations = {}
  for (const chunk of userIndexChunks.docs) {
    const chunkData = chunk.data()
    console.log('Chunk data:', chunkData)
    if (chunkData && chunkData.installations) {
      for (const installation of chunkData.installations) {
        installations[installation.id] = new ExtensionInstallation(installation)
      }
    }
  }
  return installations
}
